module.exports = __webpack_public_path__ + "img/ava-6.98fdf92d.png";